<template>
  <div class="introduceWrap clearFix">
    <div id="Template_pageHeader" class="introduceMenu">
      <div>
        <ul>
          <li @click="scrollEvent(0)" @keydown="scrollEvent(0)">상품 옵션</li>
          <li @click="scrollEvent(1)" @keydown="scrollEvent(1)">상품 소개</li>
          <li @click="scrollEvent(3)" @keydown="scrollEvent(3)">고객 리뷰</li>
        </ul>
        <div :style="moveBar" />
      </div>
    </div>
    <div id="template_fixed_Header" class="introduceMenu fixed">
      <div>
        <ul>
          <li @click="scrollEvent(0)" @keydown="scrollEvent(0)">상품 옵션</li>
          <li @click="scrollEvent(1)" @keydown="scrollEvent(1)">상품 소개</li>
          <li @click="scrollEvent(3)" @keydown="scrollEvent(3)">고객 리뷰</li>
        </ul>
        <div :style="moveBar" />
      </div>
    </div>
    <div class="introduceBox">
      <div>
        <div v-show="params === 'Dwarf'">
          <img src="@/assets/intro/intro_dwarf_1.png" alt="" />
        </div>
        <div v-show="params === 'Fan'">
          <img src="@/assets/intro/intro_fan_1.png" alt="" />
        </div>
        <div v-show="params === 'Carabiner'">
          <img src="@/assets/intro/intro_carabiner_1.png" alt="" />
        </div>
        <div v-show="params === 'Wheel'">
          <img src="@/assets/intro/intro_wheel_1.png" alt="" />
        </div>
        <!-- 기본 인쇄면, 포장방법 (카라비너, 관람차일때 숨김) -->
        <div v-show="params !== 'Carabiner' && params !== 'Wheel'">
          <img src="@/assets/intro/intro_bookmark_2.png" alt="" />
        </div>
        <div v-show="params !== 'Carabiner' && params !== 'Wheel'">
          <img src="@/assets/intro/intro_card_3.png" alt="" />
        </div>

        <div>
          <img src="@/assets/intro/intro_6.png" alt="" />
        </div>
        <div>
          <img src="@/assets/intro/intro_delivery_1.png" alt="" />
        </div>
        <div><img src="@/assets/intro/intro_delivery_2.png" alt="" /></div>
        <div v-show="params !== 'Carabiner' && params !== 'Wheel'">
          <img src="@/assets/intro/intro_delivery_3.png" alt="" />
        </div>
        <!-- 카라비너일때 상품정보 -->
        <div v-show="params === 'Carabiner'">
          <img src="@/assets/intro/intro_carabiner_delivery.png" alt="" />
        </div>
        <!-- 관람차일때 상품정보 -->
        <div v-show="params === 'Wheel'">
          <img src="@/assets/intro/intro_wheel_delivery.png" alt="" />
        </div>
      </div>
    </div>
    <review-container />
  </div>
</template>

<script>
import ReviewContainer from '../../../containers/Review/ReviewContainer.vue'

export default {
  components: {
    ReviewContainer,
  },
  props: {
    params: {
      type: String,
    },
    moveBar: {
      type: Object,
    },
  },
  methods: {
    scrollEvent(i) {
      this.$emit('scrollEvent', i)
    },
  },
}
</script>

<style scoped lang="scss">
.introduceWrap {
  width: 100%;
  min-width: 1160px;
  margin: 0 auto;

  > .introduceMenu {
    width: 100%;
    min-width: 1160px;
    text-align: center;
    background-color: #fff2f7;
    height: 72px;
    line-height: 72px;

    &.fixed {
      display: none;
    }

    > div {
      width: 1160px;
      text-align: center;
      margin: 0 auto;
      position: relative;

      > ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;

        > li {
          display: inline-block;
          margin: 0 30px;
          font-size: 15px;
          color: #707070;
          cursor: pointer;
        }
      }
    }
  }

  > .introduceBox {
    width: 100%;
    min-width: 1160px;
    margin: 0 auto;
    padding-top: 100px;

    > div {
      > div {
        text-align: center;
        padding-top: 85px;

        &.last {
          padding-bottom: 100px;
        }
      }
    }
  }

  > .scrolled {
    display: block !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 98;
  }
}
</style>
